<!-- Footer -->
<footer class="text-center text-lg-start bg-light text-muted border-bottom">
    <!-- Section: Links  -->
    <section class="">
        <div class="container text-left text-md-start mt-5">
            <!-- Grid row -->
            <div class="row mt-3">
                <!-- Grid column -->
                <div class="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4 mt-4">
                    <!-- Content -->
                    <h6 class="fw-bold mb-4">
                       Acerca de nosotros
                    </h6>
                    <p>
                        <a href="#!" class="text-reset">¿Quiénes somos?</a>
                    </p>
                    <p>
                        <a href="#!" class="text-reset">Política de privacidad</a>
                    </p>
                </div>
                <!-- Grid column -->

                <!-- Grid column -->
                <div class="col-md-3 col-lg-3 col-xl-3 mx-auto mb-4 mt-4">
                    <!-- Links -->
                    <h6 class="fw-bold mb-4">
                        ¿Necesitas ayuda?
                    </h6>
                    <p>
                        <a href="#!" class="text-reset">Preguntas frecuentes</a>
                    </p>
                    <p>
                        <a href="/contacto" class="text-reset">Contacto</a>
                    </p>
                </div>
                <!-- Grid column -->

                <!-- Grid column -->
                <div class="col-md-5 col-lg-3 col-xl-3 mx-auto mb-4 mt-4">

                    <h6 class="fw-bold mb-4">
                        Seguínos en:
                    </h6>
                    <a href="" class="me-4 text-reset mr-3">
                        <i class="fab fa-facebook-f"></i>
                    </a>
                    <a href="" class="me-4 text-reset mr-3">
                        <i class="fab fa-twitter"></i>
                    </a>
                    <a href="" class="me-4 text-reset">
                        <i class="fab fa-instagram"></i>
                    </a>


                </div>
                <!-- Grid column -->
            </div>
            <!-- Grid row -->
        </div>
    </section>
    <!-- Section: Links  -->

    <!-- Copyright -->
    <div class="text-center p-2" style="background-color: rgba(0, 0, 0, 0.05);">
        © 2021 Copyright:
        <a class="text-reset fw-bold">Grupo Beta - UNLaM</a>
    </div>
    <!-- Copyright -->
</footer>
<!-- Footer -->